import { Channel } from 'models/Channels';

export const SUPPORTED_CHANNELS = [
  Channel.orbirental,
  Channel.airbnb,
  Channel.booking_com,
  Channel.homeaway,
  Channel.google,
  Channel.hvmi,
] as const satisfies Channel[];
